import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsMX: CultureInfo = {
  name: 'es-MX',
  displayName: 'Spanish (Mexico)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-MX',
  parent: CultureInfoEs
};
